var that;
import QrcodeVue from 'qrcode.vue'
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    //导入组件
    components: {
        QrcodeVue,
    },
    data() {
        return {
            memberId: '',
            timer: null,
            show: false,
            qcsize: 200,
            qrCode123: '',
            dhrecordList: [

            ],
            activeId: 1,
            activeIndex: 0,
        };
    },

    created() {
        that = this;
        this.memberId = this.$route.query.memberId;
        this.getBookShopCardList();
    },

    mounted() {

        if (this.show == false) {
            clearInterval(this.timer);
        }

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },
    methods: {


        // 列表接口
        getBookShopCardList() {
            this.$api.getBookShopCardList({
                params: {
                    memberId: this.$route.query.memberId,
                },
                success: function(res) {
                    console.log("resres1111", res);
                    that.dhrecordList = res.data
                    console.log("dhrecordListchildren", that.dhrecordList[that.activeId-1].children);
                }
            })
        },

        //出示兑换码
        showDhCode(val) {
            this.show = true;
            console.log("dhCode", val);
            this.qrCode123 = val;
            // 定时任务  3-5s刷新
            this.timer = setInterval(() => {
                this.isBookShopWriteOff(val);
            }, 3000);

        },
        // 消费券是否核销过
        isBookShopWriteOff(val) {
            this.$api.isBookShopWriteOff({
                params: {
                    dhCode: val,
                },
                success: function(res) {
                    console.log("isBookShopWriteOff", res);
                    // 核销状态 0： 未核销 1： 已核销
                    if (res.data == "1") {
                        location.reload();
                        console.log("dhstatus", res.data);
                        clearInterval(this.timer);
                    } else {
                        console.log("dhstatus", res.data);
                        this.show = true;
                    }

                }
            })
        },
        // 点击遮罩事件
        closeDialog() {
            console.log("点击遮罩");
            clearInterval(this.timer);
        }
    }
};